import client from '@/plugins/axios.js'


export default  {
    optionsMap(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/return/map')
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
    claims(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/return/claims')
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
    adminPendingClaims(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/return/adminPendingClaims')
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },
    adminAllClaims(){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/return/adminAllClaims')
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        });
    },

    verifyReturnViability(lineId){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true}).get('/api/return/verifyReturnViability/'+lineId)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        })
    },
    adminUpdateClaim(payload){
        return new Promise((resolve, reject)=>{
            client({requiresAuth:true}).post('/api/return/adminUpdateClaim', payload)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })


        })
    },
    addClaimComment(payload){
        return new Promise((resolve, reject)=>{
            let data = {
                claimid:payload.claimId
            }

            if(payload?.content?.length > 0 ?? false){
                data['comment'] = payload.content
            }
            if(payload?.image > 0 ?? false){
                data['mediaid'] = payload.image
            }
            client({requiresAuth:true}).post('/api/return/claimComment',data)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })


        })
    },
    makeClaim(claimObject){
        return new Promise((resolve, reject)=>{
            client({requiresAuth:true, errAsObj:true}).post('/api/return/makeClaim', claimObject)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })


        })
    },
    markClaimAsRead(claimObject){
        return new Promise((resolve, reject)=>{
            client({requiresAuth:true}).post('/api/return/markClaimAsRead', claimObject)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })


        })
    },
    generateReturnShipment(payload){
        return new Promise((resolve, reject)=>{
            client({requiresAuth:true}).post('/api/return/generateReturnShipment', payload)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })


        })
    },
    loadClaim(claimId){
        return new Promise((resolve, reject)=>{
            client({requiresAuth:true}).get('/api/return/claim/'+claimId)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        })
    },
    uploadMoneyBack(formData){
        return new Promise((resolve,reject)=>{
            client({requiresAuth:true, fileUpload:true}).post('/api/media/upload', formData)
                .then((res)=>{
                    resolve(res.data.data)
                })
                .catch((err)=>{
                    reject(err)
                })
        })



    },
  uploadErrorImage(formData){
    return new Promise((resolve,reject)=>{
      client({requiresAuth:true, fileUpload:true}).post('/api/media/upload', formData)
        .then((res)=>{
          resolve(res.data.data)
        })
        .catch((err)=>{

          console.log("service:returns.js - uploadErrorImage: API returned error. I sent:",formData);
          reject(err)
        })
    })
  }
}
